const initialState = {}

export default (state = initialState, action) => {
  switch (action.type) {
    case "company/SET_COMPANY":
      return {
        ...state,
        [action.companyUUID]: {
          ...state[action.companyUUID],
          result: action.payload,
        },
      }
    case "company/SET_LOADING":
      return {
        ...state,
        [action.companyUUID]: {
          ...state[action.companyUUID],
          loading: action.payload,
        },
      }
    case "company/SET_ERROR":
      return {
        ...state,
        [action.companyUUID]: {
          ...state[action.companyUUID],
          error: action.payload,
        },
      }
    case "LOGOUT":
      return initialState
    default:
      return state
  }
}
